<div class="image-review">
  @if (isFaceComparisonLoading()) {
    <p class="nova-body-large">
      {{ "id-verification.review.faceComparisonLoadingMessage" | translate }}
    </p>
  } @else {
    <div>
      <h1 class="image-review__heading nova-heading-24">
        {{ headingTranslationKey() | translate }}
      </h1>
      <p class="image-review__subheading nova-body-large">
        {{ subheadingTranslationKey() | translate }}
      </p>
    </div>
    <img
      data-private
      [src]="image()"
      [attr.alt]="'id-verification.review.capturedPhotoAltText' | translate"
      class="image-review__photo"
    />
    @if (!hasError()) {
      <p class="image-review__bottom-text nova-body-medium">
        {{ "id-verification.review.retakeMessage" | translate }}
      </p>
    }
    <div class="action-buttons-inline">
      <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
    </div>
  }
</div>
@if (!isFaceComparisonLoading()) {
  <div class="esign-action-footer">
    <ng-container *ngTemplateOutlet="actionButtons"></ng-container>
  </div>
}

<app-simple-dialog
  [title]="'id-verification.needHelp.dialogTitle' | translate"
  [analyticsPrefix]="'id-review:help-dialog'"
  #helpDialog
>
  <p>
    {{ "id-verification.needHelp.dialogContent" | translate }}
    <a
      novaLink
      variant="simple"
      appTrackedLink
      [trackId]="'id-review:help-dialog:call-support'"
      href="tel:{{ supportPhoneNumber }}"
      >{{ supportPhoneNumber }}</a
    >.
  </p>
</app-simple-dialog>

<ng-template #actionButtons>
  <button
    novaButton
    appTrackedButton
    [trackId]="'id-review:retake'"
    [trackType]="'back'"
    [variant]="hasError() ? 'primary' : 'secondary'"
    (click)="retakeImage()"
  >
    <nova-icon class="nova-button__icon-left" [size]="24" name="photo_camera" />
    {{ "id-verification.review.retakeButtonText" | translate }}
  </button>

  @if (hasError()) {
    <button
      novaButton
      appTrackedButton
      [trackId]="'id-review:need-help'"
      variant="tertiary"
      (click)="helpDialog.open()"
    >
      {{ "id-verification.needHelp.buttonText" | translate }}
    </button>
  } @else {
    <button
      novaButton
      appTrackedButton
      [trackId]="'id-review:continue'"
      [trackType]="'continue'"
      (click)="submitImage()"
    >
      {{ "id-verification.review.continueButtonText" | translate }}
    </button>
  }
</ng-template>
